import { ModuleRoutes } from '@kiplin/web-common/architecture-core';
import { loadLazyAppModuleGuard } from '@kiplin/web-common/dependency-injection';
import { MessagingRouteName } from '@client/feature/messaging/application/routes/messaging.route-name';
import { checkClientSelected } from '@client/common/router/application/routes/check-client-selected.route-guard';
import type { Container } from 'inversify';
import type { RouteRecordRaw } from 'vue-router';

const MessagingAppModule = () => import('@client/feature/messaging/messaging.app-module');
const ClientMessagesPage = () => import('@client/feature/messaging/application/page/ClientMessagesPage.vue');

export class MessagingModuleRoutes extends ModuleRoutes<MessagingRouteName> {
  constructor(container: Container) {
    const routes: RouteRecordRaw[] = [
      {
        path: 'messaging',
        name: MessagingRouteName.ClientMessagesPage,
        component: ClientMessagesPage,
        beforeEnter: [loadLazyAppModuleGuard(MessagingAppModule, container), checkClientSelected],
      },
    ];

    super(routes);
  }
}
